import { Banner, BannerProps, Box, Text } from '@electricjs/arc';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const OrderedList = styled.ol`
  padding-left: 2rem;
`;

const StyledUl = styled.ul`
  margin: 0;
  padding-left: 24px;
`;

type QRCodeHowItWorksProps = {
  listProps?: React.HTMLAttributes<HTMLOListElement>;
};

export const QRCodeHowItWorks = ({ listProps }: QRCodeHowItWorksProps) => {
  const { t } = useTranslation('pages');

  return (
    <Box width="100%">
      <Text variant="label-large">{t('shipLaptop.instructions.title')}</Text>
      <Text>
        <OrderedList {...listProps}>
          <li>{t('shipLaptop.instructions.step1')}</li>
          <li>{t('shipLaptop.instructions.step2')}</li>
        </OrderedList>
      </Text>
    </Box>
  );
};

type QRCodeLimitationsBannerProps = {
  bannerProps?: Partial<BannerProps>;
};

export const QRCodeLimitationsBanner = ({
  bannerProps,
}: QRCodeLimitationsBannerProps) => {
  const { t } = useTranslation('pages');
  const [showBanner, setShowBanner] = useState(true);

  return showBanner ? (
    <Banner
      id="limitations-banner"
      title={t('shipLaptop.instructions.limitationsTitle')}
      message={() => (
        <Text>
          <StyledUl>
            <li>{t('shipLaptop.instructions.limitation1')}</li>
            <li>{t('shipLaptop.instructions.limitation2')}</li>
          </StyledUl>
        </Text>
      )}
      intent="info"
      isFlat
      dismissible
      onClickDismiss={() => setShowBanner(false)}
      width="fit-content"
      {...bannerProps}
    />
  ) : null;
};
